export const paymentOptions = [
  {
    id: 0,
    paymentScheduleName: "Before F2F Consult",
    paymentTransactionName: "F2F Consultation Payment",
  },
  {
    id: 1,
    paymentScheduleName: "Before Scanning",
    paymentTransactionName: "Scanning Payment",
  },
  {
    id: 2,
    paymentScheduleName: "Before Designing",
    paymentTransactionName: "Design Payment",
  },
  {
    id: 3,
    paymentScheduleName: "Balance Divided By Number of Sets",
    paymentTransactionName: "Set Payment",
  },
  {
    id: 4,
    paymentScheduleName: "Balance Divided By Number of Payments",
    paymentTransactionName: "Set Payment",
  },
  {
    id: 5,
    paymentScheduleName: "No Payment Required",
    paymentTransactionName: "NA",
  },
];
